import React, { useState } from 'react';
import LocalModal from '../base/local-modal';
import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';
import { DepartmentType } from 'models/department.model';
const EditDepartment = ({
  show,
  onClose,
  activeDepartment,
  onRefresh
}: {
  show: boolean;
  onClose: () => void;
  activeDepartment: DepartmentType;
  onRefresh: () => void;
}) => {
  const [name, setName] = useState(activeDepartment?.name);
  const [loading, setLoading] = useState(false);
  const editDepartment = async () => {
    setLoading(true);
    try {
      await apiService.put(`department`, {
        data: {
          department_id: activeDepartment?.id,
          name
        }
      });
      toast(<ToastMessage type='success' message='Department updated successfully' />);
      activeDepartment.name = name;
      onRefresh();
    } catch (err) {
      handleApiError(err, 'Error updating department');
    } finally {
      setLoading(false);
      onClose();
    }
  };
  return (
    <div>
      <LocalModal
        isOpen={show}
        title='Edit department'
        description={``}
        onRequestClose={() => onClose()}
        footer={
          <div className='flex gap-5 justify-end '>
            <Button
              onClick={onClose}
              className='w-[139px] h-[41px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031] text-sm'
              color='gray'
              small
              variant='block'>
              Cancel
            </Button>
            <Button
              className='w-[139px] h-[41px] text-sm'
              color='primary'
              small
              variant='block'
              onClick={editDepartment}
              loading={loading}
              disabled={name === '' || loading}>
              Confirm
            </Button>
          </div>
        }>
        <Input
          design='bordered'
          type='text'
          label='Department name'
          placeholder='e.g Accounting'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </LocalModal>
    </div>
  );
};

export default EditDepartment;
